import { useDispatch, useSelector } from "react-redux";
import { setAccessAC, getAccessSettings } from "@entities";
import "./kh-access.scss";

import { Text, CheckBox, Button, Input } from "@ui-kit";

const KHAccess = () => {
  const dispatch = useDispatch();
  // Получаем плоский массив из стейта. 
  // Если он пустой, желательно иметь хотя бы базовые роли для старта.
  let rolesList = useSelector(getAccessSettings);
  console.log(rolesList)
  if (!Array.isArray(rolesList)) rolesList = [
    { id: 1, roleName: "ADMIN", isSubRole: false, title: "Администратор", adobe: true, adobe_dnb: true, canva: true, shutter: true },
    { id: 2, roleName: "USER", isSubRole: false, title: "Пользователь", adobe: false, adobe_dnb: false, canva: false, shutter: false },
    { id: 3, roleName: "MYTEAMART", isSubRole: true, title: "Команда", adobe: true, adobe_dnb: true, canva: true, shutter: true },
    { id: 4, roleName: "ADOBE", isSubRole: true, title: "Patreon Max adobe", adobe: true, adobe_dnb: true, canva: false, shutter: true },
  ];

  // 1. Динамически вычисляем сервисы (названия колонок с доступами).
  // Собираем все ключи из объектов и исключаем системные поля.
  const excludeKeys = ["id", "roleName", "isSubRole", "title", "createdAt", "updatedAt"];
  const allKeys = Array.from(new Set(rolesList?.flatMap(Object.keys)));
  const services = allKeys.filter((key) => !excludeKeys.includes(key));

  // --- ОБРАБОТЧИКИ ---

  // Переключение чекбоксов доступов
  const handleToggleAccess = (id, serviceName) => {
    const updatedRoles = rolesList.map((role) =>
      role.id === id ? { ...role, [serviceName]: !role[serviceName] } : role
    );
    dispatch(setAccessAC(updatedRoles));
  };

  // Изменение текстовых полей (название роли, описание)
  const handleTextChange = (id, field, value) => {
    const updatedRoles = rolesList.map((role) =>
      role.id === id ? { ...role, [field]: value } : role
    );
    dispatch(setAccessAC(updatedRoles));
  };

  // Добавление новой суброли
  const handleAddSubRole = () => {
    // Генерируем временный ID (на бэкенде он заменится на реальный при сохранении)
    const newId = `temp-${Date.now()}`;
    
    // Создаем базовый объект новой суброли
    const newSubRole = {
      id: newId,
      roleName: "NEW_SUBROLE",
      title: "Новая суброль",
      isSubRole: true,
    };

    // Динамически добавляем всем сервисам значение false по умолчанию
    services.forEach((service) => {
      newSubRole[service] = false;
    });

    dispatch(setAccessAC([...rolesList, newSubRole]));
  };

  // Удаление строки (запрещаем удалять базовые ADMIN и USER)
  const handleDeleteRow = (id, isSubRole) => {
    if (!isSubRole) {
      alert("Базовые роли (ADMIN, USER) нельзя удалить!");
      return;
    }
    const updatedRoles = rolesList.filter((role) => role.id !== id);
    dispatch(setAccessAC(updatedRoles));
  };

  return (
    <div className="kh-access">
      <div className="kh-access__header mb-24" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Text as="h5" className="subtitle">
          Настройки доступов ролей и субролей
        </Text>
      </div>

      <div className="kh-access__content">
        <div className="table" style={{ width: "100%", textAlign: "left" }}>
          
          {/* ШАПКА ТАБЛИЦЫ */}
          <div className="table-header">
            <div className="header__name"><Text as="h5">Name</Text></div>
            <div className="header__subname"><Text as="h5">Title</Text></div>
            
            {/* Динамически рендерим колонки сервисов */}
            {services.map((service) => (
              <div key={service} className="header__service">
                <Text as="h5">{service.toUpperCase()}</Text>
              </div>
            ))}
            
            <div className="header__action" ><Text as="h5"></Text></div>
          </div>

          {/* ТЕЛО ТАБЛИЦЫ */}
          <div className="table__body">
            {rolesList.map((role) => (
              <div
                key={role.id}
                className="table__row"
              >
                {/* КОЛОНКА 1: ИМЯ РОЛИ */}
                <div style={{ flex: "0 0 150px" }}>
                  {role.isSubRole ? (
                    <Input
                      type="text"
                      value={role.roleName}
                      onChange={(e) => handleTextChange(role.id, "roleName", e.target.value)}
                      style={{ width: "100%", padding: "4px" }}
                    />
                  ) : (
                    <Text as="h6">{role.roleName}</Text> // Базовые роли не редактируем по имени
                  )}
                </div>

                {/* КОЛОНКА 2: ОПИСАНИЕ */}
                <div style={{ flex: "0 0 200px" }}>
                  <Input
                    type="text"
                    isDisabled={!role.isSubRole}
                    value={role.title || ""}
                    placeholder="Описание подписки"
                    onChange={(e) => handleTextChange(role.id, "title", e.target.value)}
                    style={{ width: "100%", padding: "4px" }}
                  />
                </div>

                {/* КОЛОНКИ СЕРВИСОВ (ДИНАМИЧЕСКИЕ ЧЕКБОКСЫ) */}
                {services.map((service) => (
                  <div key={`${role.id}-${service}`} style={{ flex: "1 1 80px", display: "flex", justifyContent: "center", paddingBottom: "14px" }}>
                    <CheckBox
                      size="sm"
                      isDisabled={!role.isSubRole}
                      checked={!!role[service]}
                      onChange={() => handleToggleAccess(role.id, service)}
                    />
                  </div>
                ))}

                {/* КОЛОНКА ДЕЙСТВИЙ */}
                <div style={{ flex: "0 0 80px", display: "flex", justifyContent: "center" }}>
                  {role.isSubRole && (
                    <Button
                      onClick={() => handleDeleteRow(role.id, role.isSubRole)}
                      style={{ color: "red", cursor: "pointer", background: "none", border: "none" }}
                      title="Delete subrole"
                      size="sm"
                      theme="link"
                    >
                      ❌
                    </Button>
                  )}
                </div>
              </div>
            ))}
          </div>
          
        </div>
        <Button 
          onClick={handleAddSubRole} 
          theme="primary"
          size="sm"
          className="add-btn"
        >
          Add SubRole access
        </Button>
      </div>
    </div>
  );
};

export default KHAccess;
